module.exports = __webpack_public_path__ + "media/svg-new/bad 1-1821d219.svg";